var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.registration.duplicates
    ? _c("div", { staticClass: "duplicates" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("support.duplicates.header")))]),
        _vm._v(" "),
        _c("div", [
          _c("table", { staticClass: "table table-hover" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("support.duplicates.tableColumn.type")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("support.duplicates.tableColumn.churchName"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("support.duplicates.tableColumn.email")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("support.duplicates.tableColumn.phone")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("support.duplicates.tableColumn.city")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("support.duplicates.tableColumn.country"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("support.duplicates.tableColumn.website"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("support.duplicates.tableColumn.setupState"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.registration.duplicates.internDuplicates, function(
                  duplicate
                ) {
                  return _c("tr", { staticClass: "duplicate-input" }, [
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.$t("support.duplicates.intern")) +
                          " (#" +
                          _vm._s(duplicate.id) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.name))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.email))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.telefonprivat))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.ort))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.land))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.website))]),
                    _vm._v(" "),
                    _c("td")
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.registration.duplicates.ccpDuplicates, function(
                  duplicate
                ) {
                  return _c("tr", { staticClass: "duplicate-input" }, [
                    _c("td", [
                      _vm._v(_vm._s(_vm.$t("support.duplicates.ccp")))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.churchName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.email))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.phone))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.city))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.countryCode))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.website))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(duplicate.setupStatus))])
                  ])
                })
              ],
              2
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ae1408c", { render: render, staticRenderFns: staticRenderFns })
  }
}